import React from "react";

function getRiskClassName(riskLevel = "") {
  if (/extreme/i.test(riskLevel)) return "danger-info-risk danger-info-risk--extreme";
  if (/high/i.test(riskLevel)) return "danger-info-risk danger-info-risk--high";
  if (/medium/i.test(riskLevel)) return "danger-info-risk danger-info-risk--medium";
  return "danger-info-risk danger-info-risk--low";
}

export default function DangerInfoReferenceBlocks({ data, onClose, t }) {
  return (
    <>
      {/* ---------------------------------------------- */}
      {/* 4) War / Conflict-Related Risks — SHOW ONLY IF NOT EMPTY */}
      {/* ---------------------------------------------- */}
      {data.war.length > 0 && (
        <section style={{ marginTop: 12 }}>
          <h4>⚔️ {t("danger_war")}</h4>

          <ul style={{ paddingLeft: 20 }}>
            {data.war.map((w, i) => (
              <li key={i}>
                {(() => {
                  const match = w.match(/\(([^)]+)\)/);
                  const risk = match ? match[1] : "";
                  return <span className={getRiskClassName(risk)}>{w}</span>;
                })()}
              </li>
            ))}
          </ul>
        </section>
      )}

      {/* ------------------------------ */}
      {/* 5) Disease Risks — SHOW ONLY IF NOT EMPTY */}
      {/* ------------------------------ */}
      {data.disease.length > 0 && (
        <section style={{ marginTop: 12 }}>
          <h4>🧫 {t("danger_disease")}</h4>

          <ul style={{ paddingLeft: 20 }}>
            {data.disease.map((d, i) => (
              <li key={i}>
                <b>{d.name}</b> — {d.prevention || d.notes || "—"}
                {d.riskLevel && (
                  <span className={getRiskClassName(d.riskLevel)}>
                    [{d.riskLevel}]
                  </span>
                )}
              </li>
            ))}
          </ul>
        </section>
      )}

      <button
        type="button"
        onClick={onClose}
        className="danger-info-close-button"
        aria-label={t("map_close_dangers")}
      >
        {t("danger_close")}
      </button>
    </>
  );
}
